import { cn } from "../../../../../utils/css";

type SidebarItemProps = {
  title: string;
  isActive: boolean;
  onClick: () => void;
  sectionId: string;
};

export default function SidebarItem({
  title,
  isActive,
  onClick,
  sectionId,
}: SidebarItemProps) {
  return (
    <div
      className={cn(
        "tw-rounded-md tw-px-4 tw-py-2 tw-flex tw-flex-row tw-items-center tw-justify-between tw-cursor-pointer tw-transition-colors tw-duration-100",
        isActive ? "tw-bg-neutral-200 tw-text-primary" : "tw-text-neutral-600",
      )}
      onClick={() => onClick()}
      onKeyDown={() => onClick()}
      role="button"
      tabIndex={0}
      data-section={sectionId}
    >
      <div className="tw-flex tw-items-center tw-gap-2 tw-relative">
        <span>{title}</span>
      </div>
    </div>
  );
}
